import { createReducer } from './reducerUtils'
import { map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

export const CONFIG_LOAD = 'CONFIG_LOAD'
export const CONFIG_LOAD_SUCCESS = 'CONFIG_LOAD_SUCCESS'
export const CONFIG_LOAD_FAILURE = 'CONFIG_LOAD_FAILURE'

export const configLoad = () => ({
  type: CONFIG_LOAD
})

export const configLoadSuccess = (config) => ({
  type: CONFIG_LOAD_SUCCESS,
  payload: config
})

export const configLoadFailure = (payload) => ({
  type: CONFIG_LOAD_FAILURE,
  payload,
  error: true
})

export const configLoadEpic = (action$, state$) =>
  action$.pipe(
    ofType(CONFIG_LOAD),
    map(action => configLoadSuccess(daptiv.ptb.WebConfig)),
    catchError(error => of(configLoadFailure(error)))
  )

// Reducer
const configLoadSuccessReducer = (state, config) => ({ ...config })
const configLoadFailureReducer = (state) => state

const configHandlerMapping = {
  [CONFIG_LOAD_SUCCESS]: configLoadSuccessReducer,
  [CONFIG_LOAD_FAILURE]: configLoadFailureReducer
}

const defaultConfig = ((daptiv || {}).ptb || {}).WebConfig
const configInitialState = Object.assign({}, defaultConfig)
export const configReducer = createReducer(configInitialState, configHandlerMapping)

export default configReducer



// WEBPACK FOOTER //
// ./src/store/config.js